
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { hundredthsToTokens, MANAGE_COMPANY_PERMISSION_LABEL, tokensToHundredths } from '@run-diffusion/shared';
import NumberField from '@/components/base/NumberField.vue';
import { roundAllocationSettingsPercentToNearestStep } from '@/views/Team/TeamDashboard/SetTeamAllocationSettings/utils';
import EnterpriseUpsellWrapper from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellWrapper.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';

export default Vue.extend({
	name: 'SetTeamAllocationSettings',
	props: {
		currTeam: { type: Object, default: null },
		saving: { type: Boolean, default: false },
		showCompanyBudgetDescriptionUi: { type: Boolean, default: false },
		showThisTeamPercentageUi: { type: Boolean, default: false },
		showLeaveTeamUnfundedOnCreationUi: { type: Boolean, default: false },
		sumMonthlyRunnitTokensBudget: { type: Number, default: 0 },
		value: {
			type: Object,
			default: () => ({
				monthlyRunnitTokensBudget: 0,
				isBoundToBudget: false,
				leaveTeamUnfundedOnCreation: false,
			}),
		},
	},
	data () {
		return {
			MANAGE_COMPANY_PERMISSION_LABEL,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
		currCompany () {
			return this.team && typeof this.team.company !== 'string' ? this.team.company : null;
		},
		teamBudgetPercentage () {
			const denominator: number = this.sumMonthlyRunnitTokensBudget > 0 ? this.sumMonthlyRunnitTokensBudget : 1;
			const percentage: number = this.value.monthlyRunnitTokensBudget / denominator * 100;
			return roundAllocationSettingsPercentToNearestStep(percentage);
		},
		teamTokenBalanceAfterCreation () {
			return this.value.leaveTeamUnfundedOnCreation ? 0 : this.value.monthlyRunnitTokensBudget;
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		hundredthsToTokens,
		tokensToHundredths,
		onEnterpriseBudgetsUpsell () {
			this.setUpsellDialog({ noCompanyBudgets: true });
		},
		onMonthlyRunnitTokensBudgetInput (tokens: number) {
			this.emitInput(tokens, this.value.isBoundToBudget, this.value.leaveTeamUnfundedOnCreation);
		},
		emitInput (monthlyRunnitTokensBudget: number, isBoundToBudget: boolean, leaveTeamUnfundedOnCreation: boolean) {
			this.$emit('input', {
				monthlyRunnitTokensBudget: monthlyRunnitTokensBudget > 0 ? monthlyRunnitTokensBudget : 0,
				isBoundToBudget: !!isBoundToBudget,
				leaveTeamUnfundedOnCreation: !!leaveTeamUnfundedOnCreation,
			});
		},
	},
	components: {
		BaseToggle,
		EnterpriseUpsellWrapper,
		NumberField,
	},
});
